import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Img1 from '../../images/testimonial/1.jpg'
import Img2 from '../../images/testimonial/2.jpg'
import Img3 from '../../images/testimonial/3.jpg'
import SectionTitle from '../SectionTitle/SectionTitle';


const testimonials = [
    {
        id: '01',
        img: Img1,
        Des: "Pharmacy Freedom Fund's strategic approach to pharmacy acquisition and optimization has consistently delivered exceptional returns. Their deep industry knowledge and operational expertise make them a standout investment partner in the healthcare sector.",
        title: 'Michael Richardson',
        sub: "LP Investor",
    },
    {
        id: '02',
        img: Img2,
        Des: "Partnering with Pharmacy Freedom Fund transformed our pharmacy's potential. Their operational improvements and technology integration significantly increased our valuation, leading to a successful and profitable exit. I would recommend them to any pharmacy owner",
        title: 'Sarah Thompson',
        sub: "Former Pharmacy Owner",
    },
    {
        id: '03',
        img: Img3,
        Des: "As an LP investor, I've been impressed by Pharmacy Freedom Fund's disciplined approach to identifying and acquiring undervalued pharmacies. Their focus on operational excellence and strategic growth initiatives has consistently generated attractive returns.",
        title: 'David Chen',
        sub: "Private Equity Partner",
    },
]




const Testimonial = (props) => {

    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                }
            },

        ]
    };


    return (

        <section className={"" + props.tClass} style={{ marginTop: 50 }}>
            <div className="container">
                <div className="row justify-content-left">
                    <div className="col-12">
                        <SectionTitle title='Testimonial' subtitle="Our Partners Say About Us" />
                    </div>
                </div>
                <div className="row testimonial_slider">
                    <Slider {...settings}>
                        {testimonials.map((testitem, titem) => (
                            <div className="testimonial_card" key={titem}>
                                <div className="icon">
                                    <i className="flaticon-quote"></i>
                                </div>
                                <ul>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                </ul>
                                <p>{testitem.Des}</p>
                                <div className="ath">
                                    <div className="image">
                                        <img src={testitem.img} alt="" />
                                    </div>
                                    <div className="text">
                                        <h3>{testitem.title}</h3>
                                        <span>{testitem.sub}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;

